import { useLocation, useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import formComplete from 'styles/images/icon_complete3.svg';
import iconWarning from 'styles/images/icon_warning.svg';

export const CompletePage = () => {
  const navigate = useNavigate();
  const { isSuccess, talkChannelReturnUrl } = useLocation().state;
  const processFormData = useBoundStore((state) => state.hsptlzForm.processFormData);

  if (isSuccess) {
    return (
      <div className='container-wrap hsptlz-complete-form'>
        <div className='content-area'>
          <div className='con-center'>
            <img src={formComplete} alt='작성 완료' />
            <h3 className='header-tit-01'>
              동의서 제출을 <br />
              완료했어요
            </h3>
            <p className='body-tit-03'>
              제출하신 동의서는 암호화되어
              <br />
              병원에서 안전하게 보관돼요.
            </p>
          </div>
        </div>

        <div className='btm-area default-btm'>
          <button
            className='btn btm-btn-secondary'
            onClick={() => {
              if (Object.keys(processFormData).length === 0) {
                window.location.href = talkChannelReturnUrl;
              } else {
                navigate('/hsptlz/form?tab=process', { replace: true });
              }
            }}
          >
            <span className='btn-txt-01'>
              {Object.keys(processFormData).length === 0 ? '톡채널로 돌아가기' : '동의서 목록으로 돌아가기'}
            </span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='container-wrap hsptlz-complete-form'>
      <div className='content-area'>
        <div className='con-center'>
          <img src={iconWarning} alt='작성 실패' />
          <h3 className='header-tit-01'>
            동의서 제출을 <br />
            실패했어요
          </h3>
          <p className='body-tit-03'>
            동의서 작성 중에 오류가 발생했어요.
            <br />
            잠시 후 다시 시도하거나 실패가 계속된다면
            <br />
            병원으로 문의해 주세요.
          </p>
        </div>
      </div>

      <div className='btm-area default-btm'>
        <button
          className='btn btm-btn-primary'
          onClick={() => {
            navigate('/hsptlz/form?tab=process', { replace: true });
          }}
        >
          <span className='btn-txt-01'>이전으로 돌아가기</span>
        </button>
      </div>
    </div>
  );
};
